module.exports = __webpack_public_path__ + "img/menu-lateral.e5a4cd74.png";